import { SliderBreakpoint } from './SliderConfig';
import { SliderBase } from './SliderBase';

class SliderBreakpointManager {
	private readonly breakpointKeys: string[];
	private slider: SliderBase;

	constructor(instance: SliderBase) {
		this.slider = instance;

		this.breakpointKeys = Object.keys(this.slider.config.breakpoints).sort(
			(a: string, b: string) => {
				return parseInt(a, 10) - parseInt(b, 10);
			}
		);

		window.addEventListener('resize', () => this.handleBreakpoints(), { passive: true });
		this.handleBreakpoints();
	}

	private getCurrentBreakpoint(): SliderBreakpoint | undefined {
		const currentWidth: number = window.innerWidth;
		let currentBreakpointKey: string = '';

		for (let i: number = this.breakpointKeys.length - 1; i >= 0; i -= 1) {
			if (parseInt(this.breakpointKeys[i], 10) <= currentWidth) {
				currentBreakpointKey = this.breakpointKeys[i];
				break;
			}
		}

		return this.slider.config.breakpoints[currentBreakpointKey];
	}

	private handleBreakpoints(): void {
		const currentBreakpoint: SliderBreakpoint = this.getCurrentBreakpoint();
		const itemsPerView: number = currentBreakpoint
			? Math.abs(currentBreakpoint.itemsPerView)
			: Math.abs(this.slider.config.itemsPerView);

		if (this.slider.itemsPerView !== itemsPerView) {
			this.slider.itemsPerView = itemsPerView;
			this.slider.pagination.initPagination();
		}
	}
}

export { SliderBreakpointManager };
